import { extendTheme } from "@chakra-ui/react";
import { mode } from "@chakra-ui/theme-tools";

const config = {
    initialColorMode: "dark",
    useSystemColorMode: false,
};

const styles = {
    global: (props) => ({
        body: {
            bg: mode("gray.50", "gray.900")(props),
            color: mode("gray.800", "whiteAlpha.900")(props),
            fontFamily: "'Inter', sans-serif",
        },
    }),
};

const colors = {
    brand: {
        50: "#E6FFFA",
        100: "#B2F5EA",
        200: "#81E6D9",
        300: "#4FD1C5",
        400: "#38B2AC",
        500: "#319795",
        600: "#2C7A7B",
        700: "#285E61",
        800: "#234E52",
        900: "#1D4044",
    },
    accent: {
        light: "#3182ce",
        dark: "#90cdf4",
    },
};

const components = {
    Button: {
        baseStyle: {
            fontWeight: "bold",
            borderRadius: "12px",
        },
        variants: {
            solid: (props) => ({
                bg: mode("brand.500", "brand.200")(props),
                color: mode("white", "gray.900")(props),
                _hover: {
                    bg: mode("brand.600", "brand.300")(props),
                    transform: "translateY(-2px)",
                    boxShadow: "lg",
                },
                transition: "all 0.2s",
            }),
            outline: (props) => ({
                borderColor: mode("brand.500", "brand.200")(props),
                color: mode("brand.500", "brand.200")(props),
                _hover: {
                    bg: mode("brand.50", "whiteAlpha.200")(props),
                },
            }),
            ghost: (props) => ({
                color: mode("brand.500", "brand.200")(props),
                _hover: {
                    bg: mode("brand.50", "whiteAlpha.200")(props),
                },
            }),
        },
    },
    Card: {
        baseStyle: (props) => ({
            container: {
                bg: mode("white", "gray.800")(props),
                borderRadius: "xl",
                boxShadow: mode("md", "xl")(props),
                border: "1px solid",
                borderColor: mode("gray.100", "gray.700")(props),
            },
        }),
    },
    Input: {
        variants: {
            filled: (props) => ({
                field: {
                    bg: mode("gray.100", "whiteAlpha.100")(props),
                    _hover: {
                        bg: mode("gray.200", "whiteAlpha.200")(props),
                    },
                    _focus: {
                        bg: mode("white", "gray.800")(props),
                        borderColor: "brand.500",
                    },
                    borderRadius: "10px",
                },
            }),
        },
        defaultProps: {
            variant: "filled",
        },
    },
};

const theme = extendTheme({ config, styles, colors, components });

export default theme;
